const TiktokVideoLoader = (() => {
    const Selectors = {
        DATA: 'data-tiktok'
    };
    class TiktokVideoLoader {
        constructor() {
            window.addEventListener('firstInteraction', () => {
                this.loadVideos();
            });

        }

        loadVideos() {
            const elements = document.querySelectorAll(`[${Selectors.DATA}]`);
            elements.forEach(element =>{
                let link = element.getAttribute(Selectors.DATA);
                fetch(`https://www.tiktok.com/oembed?url=${link}`)
                    .then(response => response.json())
                    .then(json => {
                        const code = json.html.split('<script>')[0];
                        const div = document.createElement('div');
                        div.innerHTML = code;
                        element.appendChild(div);

                        const tiktoksOnPage = Array.from(
                            element.querySelectorAll('blockquote.tiktok-embed'),
                        );
                        if (typeof tiktokEmbed !== 'undefined' && tiktoksOnPage.length) {
                            tiktokEmbed.lib.render(tiktoksOnPage);
                        }

                    });
            })
        }
    }

    return new TiktokVideoLoader();

})();

export default TiktokVideoLoader;
